import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconFlight = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconFlight",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M480-120 377-91q-14 4-25-4t-12-23q0-12 3-19t8-12l69-51v-220l-291 86q-19 5-34-6t-15-31q0-15 5-25t14-15l321-189v-220q0-25 18-42t42-18 43 18 17 42v220l321 189q9 5 14 15t5 25q0 20-15 31t-34 6l-291-86v220l69 51q5 4 8 12t3 19q0 14-11 23t-26 4z"
  })
}));